import { render, staticRenderFns } from "./HealthManagement.vue?vue&type=template&id=9ef2b1be&scoped=true"
import script from "./HealthManagement.vue?vue&type=script&lang=js"
export * from "./HealthManagement.vue?vue&type=script&lang=js"
import style0 from "./HealthManagement.vue?vue&type=style&index=0&id=9ef2b1be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef2b1be",
  null
  
)

export default component.exports